import { render, staticRenderFns } from "./TenantContentTab.vue?vue&type=template&id=055dd7f4"
import script from "./TenantContentTab.vue?vue&type=script&lang=ts"
export * from "./TenantContentTab.vue?vue&type=script&lang=ts"
import style0 from "./TenantContentTab.vue?vue&type=style&index=0&id=055dd7f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports